import { TransitionStartEvent } from '@mockly/events';
import { clamp, lerp } from '@mockly/animation-utils';

const selectors = {
  header: 'site-header',
  logo: '[data-about-hero-logo]'
}

class ComponentAboutHero extends HTMLElement {
  #header = null;
  #logo = null;
  #rafLoop = null;
  #progress = 0;
  #targetProgress = 0;

  constructor() {
    super();

    this.handlePageChange = this.handlePageChange.bind(this);
    this.animate = this.animate.bind(this);
  }

  handlePageChange() {
    this.siteHeader?.removeAttribute('data-hide-logo');
  }

  animate() {
    const rect = this.getBoundingClientRect();

    const offsetY = -1 * (rect.top / rect.height)
    
    this.#targetProgress = clamp(offsetY, 0, 1)

    if (this.#targetProgress >= 1) {
      this.siteHeader?.removeAttribute('data-hide-logo');
    } else {
      this.siteHeader?.setAttribute('data-hide-logo', 'true');
    }

    if ((this.#progress > 0 || this.#progress < 1) && !(this.#progress === this.#targetProgress)) {
      this.#progress = lerp(this.#progress, this.#targetProgress, 0.15)
      this.style.setProperty('--progress', this.#progress)
    }

    this.#rafLoop = requestAnimationFrame(this.animate);
  }

  connectedCallback() {
    console.log('connectedCallback');
    this.siteHeader = document.querySelector(selectors.header);
    this.logo = this.querySelector(selectors.logo);

    this.siteHeader?.setAttribute('data-hide-logo', 'true');

    this.#rafLoop = requestAnimationFrame(this.animate);

    window.addEventListener(TransitionStartEvent.eventName, this.handlePageChange);
  }

  disconnectedCallback() {
    this.siteHeader?.removeAttribute('data-hide-logo');
    window.removeEventListener(TransitionStartEvent.eventName, this.handlePageChange);
    cancelAnimationFrame(this.#rafLoop);
  }
}

if (!customElements.get('about-hero')) {
  customElements.define('about-hero', ComponentAboutHero);
}